import { Spinner } from "@magnetic/spinner";

import { VFlex } from "./vFlex";

import "./pageLoader.scss";

interface PageLoaderProps {
  readonly text?: React.ReactNode;
}

export const PageLoader = ({ text }: PageLoaderProps): React.ReactNode => {
  return (
    <div className="cnc-page-loader">
      <VFlex>
        <Spinner size="lg" />
        {text}
      </VFlex>
    </div>
  );
};
interface SectionLoaderProps {
  readonly text?: React.ReactNode;
}
export const SectionLoader = ({
  text
}: SectionLoaderProps): React.ReactNode => {
  return (
    <div className="cnc-section-loader">
      <VFlex className="section-spinner">
        <Spinner size="sm" />
        <>{text}</>
      </VFlex>
    </div>
  );
};
